import { render, staticRenderFns } from "./WebinarsView.vue?vue&type=template&id=22071360&scoped=true&"
import script from "./WebinarsView.vue?vue&type=script&lang=ts&"
export * from "./WebinarsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22071360",
  null
  
)

export default component.exports